export const sendMessage = (iframe, targetOrigin, data) => {
  if (iframe?.contentWindow) {
    iframe.contentWindow.postMessage(data, targetOrigin);
  }
};
